import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
function SearchResult(props) {
    const { title, tags, url, image, excerpt, } = props;
    const renderTags = (suppliedTags) => {
        if (!suppliedTags || suppliedTags.length < 1)
            return null;
        const tagsElements = suppliedTags.map((tag) => (_jsx("span", { className: "tag tag--category", children: tag })));
        return (_jsx("span", { className: "search-result__tags", children: tagsElements }));
    };
    return (_jsxs("a", { href: url, className: "search-result", "aria-label": `Search Result: ${title}`, children: [_jsxs("div", { className: "search-result__content", children: [renderTags(tags), _jsx("span", { className: "search-result__title", children: title }), _jsx("span", { className: "search-result__excerpt", children: excerpt })] }), image && (_jsx("div", { className: "search-result__image", children: _jsx("img", { src: image, alt: `${title}` }) }))] }));
}
export default SearchResult;
